import { render, staticRenderFns } from "./ChangeAccount.vue?vue&type=template&id=d6d779dc&scoped=true"
import script from "./ChangeAccount.vue?vue&type=script&lang=js"
export * from "./ChangeAccount.vue?vue&type=script&lang=js"
import style0 from "./ChangeAccount.vue?vue&type=style&index=0&id=d6d779dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d779dc",
  null
  
)

export default component.exports